import axios from "axios";

export const stripePaymentInitV4 = async (payload, accountPayload, getState) => {
  try {
    console.log(payload);

    const formData = new FormData();
    const refreshToken = await getState().REFFtoken; // Fetch refresh token from getState
    formData.append("payment_method", payload["payment_method"]);
    formData.append("challenge_id", payload["challenge_id"]);
    if (payload["coupon"]) formData.append("coupon", payload["coupon"]);
    formData.append("email", payload["email"]);
    if (payload["EAs"]) formData.append("EAs", payload["EAs"]);
    if (payload["raw_spread"]) formData.append("raw_spread", payload["raw_spread"]);
    if (payload["platform"]) formData.append("platform", payload["platform"]);
    formData.append("firstName", payload["firstName"]);
    formData.append("lastName", payload["lastName"]);
    formData.append("contact", payload["contact"]);
    formData.append("payout_type", payload["payout_type"]);
    formData.append("refresh_token", refreshToken);
    formData.append("cryptocurrency", payload["cryptocurrency"]);
    formData.append("ten_percent_profit_target", payload["ten_percent_profit_target"]);
    if (payload["country_code"]) formData.append("country_code", payload.country_code);

    // Make the POST request
    const response = await fetch("https://backend.alphacapitalgroup.uk/v2/get/checkout/payment-url/", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data === "Please verify the Access Token!") {
      console.warn("Access Token verification failed.");
      return;
    }

    // Handle authentication and redirection
    if (data.auth) {
      console.log("User authenticated. Handling session data.");
      // Example of saving tokens or user session (adjust as needed)
      // localStorage.setItem("idToken", data.auth.idToken);
      // localStorage.setItem("refreshToken", data.auth.refresh_token);
    }

    // Redirect to payment link
    if (data.url) {
      window.location.href = data.url;
    } else {
      console.error("Payment URL not provided.");
    }

    return data; // Return response data for further processing
  } catch (error) {
    if (error === "Please verify the Access Token!") {
      console.warn("Access Token verification failed.");
      return;
    }
    console.error("Error processing payment:", error);
    throw error; // Re-throw for further handling
  }
};

export const applyCouponCode = async (challenge_id, coupon = null, tenPercentProfit = 0) => {
  try {
    if (!challenge_id) {
      throw new Error("Challenge ID is required.");
    }

    const url = `v2/get/final-price/${challenge_id}/`;
    const params = {
      ten_percent_profit_target: tenPercentProfit ? 1 : 0,
    };
    if (coupon) {
      params.coupon = coupon;
    }

    // Base URL of your backend
    const baseUrl = "https://backend.alphacapitalgroup.uk";

    // Make the GET request with axios and query parameters
    const response = await axios.get(`${baseUrl}/${url}`, {params});
    const {data, status} = response;

    if (status > 399) {
      throw new Error(data);
    }
    return data;
  } catch (error) {
    const errorData = error.response?.data || error.message;
    console.error(errorData);

    if (error.response?.data?.detail === "Authentication credentials were not provided.") {
      console.warn("Authentication credentials are missing.");
      return;
    }
    throw errorData;
  }
};
